// extracted by mini-css-extract-plugin
export default {"content":"sportstaetten_content__3iZou","modalOverlay":"sportstaetten_modalOverlay__aiOB7","modalForm":"sportstaetten_modalForm__nAJVk"};